import type { PrescriptionPadItemDetailType } from '@/components/Patient/components/PrescriptionItemEditor/PrescriptionItemEditor.types';
import { PrescriptionPadItemDetail } from '@/components/Patient/components/PrescriptionItemEditor/PrescriptionItemEditor.types';
import type { MedicationType } from '@/components/Patient/components/ProductDetailsCard/ProductDetailsCard.types';
import { Logger } from '@/utils/logger';

const logger = new Logger('validateAndUpdatePrescriptionItemDetailUtils');

export const validateAndUpdateMedicationPadItemDetailUtil = (
  medicationPadItemDetailToUpdate: MedicationType | undefined,
  partialDetail: Partial<PrescriptionPadItemDetailType>,
) => {
  if (!medicationPadItemDetailToUpdate && !partialDetail?.productId && !partialDetail?.productName) {
    return;
  }
  const updatedPrescriptionItemDetail: PrescriptionPadItemDetailType = {
    ...medicationPadItemDetailToUpdate,
    ...partialDetail,
  } as PrescriptionPadItemDetailType; // assertion is safe, as the conditional above will early return if required props don't exit.

  const validation = PrescriptionPadItemDetail.safeParse(updatedPrescriptionItemDetail);
  if (!validation.success) {
    logger.error('validateAndUpdatePrescriptionItemDetailUtil: invalid prescription details used', {
      updatedPrescriptionItemDetail,
    });
    return;
  }
  return updatedPrescriptionItemDetail;
};
